import { ttpRegistriesUrl } from 'SharedDir/backend/endpoints/ttp-registries';

export const personDeerUrl = `${ttpRegistriesUrl}/deer`;
